import React, { useState, useEffect , useRef } from 'react'
import Select from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import ToastNotification from '../../components/ToastNotification';
import { MdEdit } from "react-icons/md";
import { FaEquals } from 'react-icons/fa';
import { FaWhatsapp } from "react-icons/fa6";
import { BsBank2 } from "react-icons/bs";
import { useLocation} from 'react-router-dom';

const PartyDetail = () => {

 const location = useLocation();
  const formRef = useRef(null);

const mode = location.state?.mode;     
  const partyId = location.state?.partyId;
  // const accountcode = location.state?.accountCode;

  const [isEditMode, setIsEditMode] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false)



useEffect(() => {
    if (mode === "isEditMode") {
      setIsEditMode(true);
      setShowAddForm(true);

      const incomingAcc = location.state?.accountData;
      const incomingAccId = location.state?.accountId;
      const incomingCode = location.state?.accountCode || location.state?.accountcode;

      if (incomingAcc) {
        setAccountData({
          id: incomingAcc.id || '',
          holder_name: incomingAcc.holder_name || '',
          code: incomingAcc.code || '',
          type_account: incomingAcc.type_account || '',
          parent: incomingAcc.parent || '',
          op_bal: incomingAcc.op_bal !== undefined ? incomingAcc.op_bal : '',
          budget: incomingAcc.budget !== undefined ? incomingAcc.budget : '',
          days: incomingAcc.days !== undefined ? incomingAcc.days : '',
          party_id: incomingAcc.party_id || '',
        });
        setAccountCode(incomingAcc.code || '');
        setHasAccount(true);
      } else if (incomingAccId) {
        axios.get('https://api.skyguard.group/api/fetch-account').then(res => {
          if (res.data && res.data.result) {
            const found = res.data.result.find(a => String(a.id) === String(incomingAccId));
            if (found) {
              setAccountData({
                id: found.id,
                holder_name: found.holder_name || '',
                code: found.code || '',
                type_account: found.type_account || '',
                parent: found.parent || '',
                op_bal: found.op_bal !== undefined ? found.op_bal : '',
                budget: found.budget !== undefined ? found.budget : '',
                days: found.days !== undefined ? found.days : '',
                party_id: found.party_id || '',
              });
              setAccountCode(found.code || '');
              setHasAccount(true);
            }
          }
        }).catch(err => console.error(err));
      }

      if (partyId) {
        setEditingCompanyId(partyId);
        fetchPartyById(partyId).then(() => {
          if (incomingCode) {
            setAccountCode(incomingCode);
          } else {
            fetchAccountCodeByParty(partyId);
          }

          if (!incomingAcc && !incomingAccId) {
            axios.get('https://api.skyguard.group/api/fetch-account').then(res => {
              if (res.data && res.data.result) {
                const found = res.data.result.find(a => String(a.party_id) === String(partyId));
                if (found) {
                  setAccountData({
                    id: found.id,
                    holder_name: found.holder_name || '',
                    code: found.code || '',
                    type_account: found.type_account || '',
                    parent: found.parent || '',
                    op_bal: found.op_bal !== undefined ? found.op_bal : '',
                    budget: found.budget !== undefined ? found.budget : '',
                    days: found.days !== undefined ? found.days : '',
                    party_id: found.party_id || '',
                  });
                  setAccountCode(found.code || '');
                  setHasAccount(true);
                }
              }
            }).catch(err => console.error(err));
          }
        });
      } else if (incomingAcc) {
        setNewProduct(prev => ({
          ...prev,
          name: incomingAcc.holder_name || '',
          address: incomingAcc.party_address || '',
          phone: incomingAcc.party_phone || incomingAcc.party_mobile || '',
          email: incomingAcc.party_email || '',
          type_account: incomingAcc.type_account || '',
        }));
      }
    }
  }, [mode, partyId, location.state]);


  const getAccountTypeName = (typeVal) => {
    if (!typeVal) return "";
    const found = accountType.find(
      (at) => String(at.id) === String(typeVal) || at.type_acc === typeVal
    );
    return found ? found.type_acc : typeVal;
  };

  const handleAccountInputChange = (e) => {
    const { name, value } = e.target;
    setAccountData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchAccountsList = async () => {
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-account');
      if (res.data && res.data.result) {
        setParentAccounts(res.data.result);
        setAllAccounts(res.data.result);
      }
    } catch (err) {
      console.error('Error fetching accounts in PartyDetail:', err);
    }
  };

  const handleCancel = () => {
    if (location.state?.from === "accounts") {
      navigate("/admin/accounts");
    } else {
      setShowAddForm(false);
      setIsEditMode(false);
      setEditingCompanyId(null);
      setEditProductId(null);
      setAccountData({
        id: '',
        holder_name: '',
        code: '',
        type_account: '',
        parent: '',
        op_bal: '',
        budget: '',
        days: '',
        party_id: '',
      });
      setHasAccount(false);
      setNewProduct({
        name: '',
        parent: '',
        address: "",
        landmark: '',
        city: "",
        pin: '',
        phone: '',
        email: '',
        priority: '',
        type: '',
        remark: '',
        state: '',
        region: '',
        birth: '',
        fax: '',
        mobile: '',
        pan: '',
        gst: '',
        profession: '',
        source: '',
        prodct: '',
        phone_two: '',
        phone_three: '',
        profession_type: '',
        contact_name: '',
        contact_no: '',
        currentAdd: '',
        post_one: '',
        post_two: '',
        post_three: '',
        isAccountChecked: false,
        wasAccountChecked: false,
        customer_type: '',
        alt1_contact_name: '',
        alt2_contact_name: '',
        alt3_contact_name: '',
        cin: '',
        msme: ''
      });
      setAccountCode('');
    }
  };

const fetchAccountCodeByParty = async (partyId) => {
  try {
    const res = await axios.get(`https://api.skyguard.group/api/get-account-code/${partyId}`);
    if (res.data && res.data.account_code) {
      setAccountCode(res.data.account_code);
     
    }
  } catch (error) {
    console.error("Error fetching account code:", error);
  }
};


const fetchAccountCode = async (partyId) => {
  try {
    const res = await axios.get(`https://api.skyguard.group/api/get-account-code/${partyId}`);

    if (res.data && res.data.account_code) {
      setAccountCode(res.data.account_code);
    } else {
      setAccountCode(""); 
    }
  } catch (err) {
    console.error("Error fetching account code:", err);
    setAccountCode("");
  }
};



useEffect(() => {
 
  
  if (location.state && location.state.showAddForm) {
    setShowAddForm(true);

    const partyData = location.state.partyData;


    if (partyData) {
      setNewProduct({
        name: partyData.party || "",
        address: partyData.site || "",
        phone: partyData.mobile || "",
       state: partyData.state || "",
        city: partyData.city || "",
         region: partyData.region || "",
          pin: partyData.pincode || "",
      });
   
    }

  
  }
}, [location.state]);


 const navigate = useNavigate('');
  const [coords, setCoords] = useState({ latitude: null, longitude: null });
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null)
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);

  const [partyMaster, setPartyMaster] = useState([]);
  const [type, setType] = useState([]);
  const [profession, setProfession] = useState([]);
  const [typeProfessin, setTypeProfession] = useState([]);
  const [source, setSource] = useState([]);
  const [parent, setParent] = useState([]);

  const [postOneOptions, setPostOneOptions] = useState([]);
  const [postTwoOptions, setPostTwoOptions] = useState([]);
  const [postThreeOptions, setPostThreeOptions] = useState([]);

  const [detail, setDetail] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
     const [accountType, setAccountType] = useState([]);
  const [fetchAccountType,setFetchAccoutnType] = useState([]);
  const [accountData, setAccountData] = useState({
    id: '',
    holder_name: '',
    code: '',
    type_account: '',
    parent: '',
    op_bal: '',
    budget: '',
    days: '',
    party_id: '',
  });
  const [parentAccounts, setParentAccounts] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: '',
    parent: '',
    address: "",
    landmark: '',
    city: "",
    pin: '',
    phone: '',
    email: '',
    priority: '',
    type: '',
    remark: '',
    state: '',
    region: '',
    birth: '',
    fax: '',
    mobile: '',
    pan: '',
    gst: '',
    profession: '',
    source: '',
    prodct: '',
    phoneChecked_two:'',
    phone_three: '',
    profession_type: '',
    contact_name: '',
    contact_no: '',
    currentAdd: '',
    post_one: '',
    post_two: '',
    post_three: '',
    isAccountChecked: false,
    phoneChecked_one:false,
    phoneChecked:false,
    phoneChecked_two:false,
    phoneChecked_three:false,
    phoneChecked_contact:false,
    type_account:'',
    customer_type:'',
    account_code:'',
    alt1_contact_name: '',
    alt2_contact_name: '',
    alt3_contact_name: '',

    cin:'',
    msme:'',

  });

  
  const [editingCompanyId, setEditingCompanyId] = useState(null);     
  const [showPostModal, setShowPostModal] = useState(false);
  const [newPostName, setNewPostName] = useState("");
  const [activePostField, setActivePostField] = useState(null);
 const [editProductId, setEditProductId] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
const [accountCode, setAccountCode] = useState("");
const [hasAccount, setHasAccount] = useState(false);


  const getCurrentLoc = () => {
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by your browser.");
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
   
         setCoords({ latitude, longitude });

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await response.json();
          setLoading(false);
          if (data && data.display_name) {
            setNewProduct((prev) => ({
              ...prev,
              currentAdd: data.display_name,
            }));
          } else {
       
            setNewProduct((prev) => ({
              ...prev,
              currentAdd: "Address not found",
            }));
          }
        } catch (error) {
          console.error("Error fetching address:", error);
          setLoading(false);
        }
      },
      (err) => {
        console.error("Geolocation error:", err);
      }
    );
  };



  const priorityOptions = [
    { value: '1', label: 'High' },
    { value: '2', label: 'Medium' },
    { value: '3', label: 'Normal' },
  ]


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 2) {
        showToast("File size is too large! Please upload a file smaller than 2MB.", 'danger');
        return; 
      }
      setFiles({ ...files, [e.target.name]: file });
    }
  };

  const [files, setFiles] = useState({
    file: null,
    video: null

  })

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); 
      if (fileSizeInMB > 5) {
        showToast("Video size is too large! Please upload a video smaller than 5MB.", 'danger');
        return;
      }
      setFiles((prev) => ({
        ...prev,
        [e.target.name]: file, 
      }));
    }
  };



const handleInputChange = (e) => {
  const { name, value } = e.target;

  setNewProduct((prev) => ({
    ...prev,
    [name]: value,
    ...(isEditMode && name === "phone" ? { phoneChecked_one: false } : {}),
    ...(isEditMode && name === "phone_two" ? { phoneChecked_two: false } : {}),
    ...(isEditMode && name === "phone_three" ? { phoneChecked_three: false } : {}),
    ...(isEditMode && name === "mobile" ? { phoneChecked: false } : {}),
      ...(isEditMode && name === "contact_no" ? { phoneChecked_contact: false } : {}),

  }));


  if (name === "pin" && value === "") {
    setNewProduct((prev) => ({
      ...prev,
      state: "",
      region: "",
      city: "",
    }));
    return;
  }
};



  const handleEdit = async(form) => {

    setNewProduct({
      id: form.id || '',
      name: form.name || "",
      parent: form.parent || "",
      address: form.address || "",
      landmark: form.landmark || "",
      city: form.city || "",
      pin: form.pin || "",
      phone: form.phone || "",
      email: form.email || "",
      priority: form.priority || "",
      type: form.type || "",
      remark: form.remark || "",
      state: form.state || "",
      region: form.region || "",
      birth: form.birth || "",
      fax: form.fax || "",
      mobile: form.mobile || "",
      pan: form.pan || "",
      gst: form.gst || "",
      profession: form.profession || '',
      source: form.source || '',
      phone_two: form.phone_two || '',
      phone_three: form.phone_three || '',
      profession_type: form.profession_type || '',
      contact_name: form.contact_name || '',
      contact_no: form.contact_no || '',
      product: form.product || '',
      profession: form.profession || '',
      source: form.source || '',
      currentAdd: form.currentAdd || '',
      post_one: form.post_one || '',
      post_two: form.post_two || '',
      post_three: form.post_three || '',
      isAccountChecked: form.isAccountChecked ?? false,
      //  isAccountChecked: form.isAccountChecked === 1,
        wasAccountChecked: form.isAccountChecked === 1,
          phoneChecked_one: form.phoneChecked_one || false,
          phoneChecked: form.phoneChecked || false,
          phoneChecked_two: form.phoneChecked_two || false ,
          phoneChecked_three:form.phoneChecked_three || false,
          phoneChecked_contact:form.phoneChecked_contact || false,
      type_account:form.type_account ? String(form.type_account)  : "",
      customer_type:form.customer_type || "",
      alt1_contact_name: form.alt1_contact_name || "",
      alt2_contact_name: form.alt2_contact_name || "",
      alt3_contact_name: form.alt3_contact_name || "",

      account_code: form.account_code || "",

      cin:form.cin || "",
      msme:form.msme || "",
    })


    setFiles({

      file: form.file || null,
      video: form.video || null
    });

setAccountCode(form.account_code || "");
    axios.get('https://api.skyguard.group/api/fetch-account').then(res => {
      if (res.data && res.data.result) {
        setParentAccounts(res.data.result);
        setAllAccounts(res.data.result);
        const linkedAcc = res.data.result.find(a => String(a.party_id) === String(form.id));
        if (linkedAcc) {
          setAccountData({
            id: linkedAcc.id,
            holder_name: linkedAcc.holder_name || form.name || '',
            code: linkedAcc.code || form.account_code || '',
            type_account: linkedAcc.type_account || form.type_account || '',
            parent: linkedAcc.parent || '',
            op_bal: linkedAcc.op_bal !== undefined ? linkedAcc.op_bal : '',
            budget: linkedAcc.budget !== undefined ? linkedAcc.budget : '',
            days: linkedAcc.days !== undefined ? linkedAcc.days : '',
            party_id: linkedAcc.party_id || form.id
          });
          setAccountCode(linkedAcc.code || form.account_code || '');
          setHasAccount(true);
        } else {
          setAccountData({
            id: '',
            holder_name: form.name || '',
            code: form.account_code || '',
            type_account: form.type_account || '',
            parent: '',
            op_bal: '',
            budget: '',
            days: '',
            party_id: form.id
          });
          setHasAccount(Boolean(form.account_code));
        }
      }
    }).catch(err => console.error(err));

    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowAddForm(true);

    // setHasAccount(!!form.account_code);

    setHasAccount(
  form.account_code !== null &&
  form.account_code !== undefined &&
  String(form.account_code).trim() !== ""
);
  };




const callAddAccountAPI = async (partyId, holderName,typeAccount) => {
  const accountData = {
    holder_name: holderName,
    type_account: typeAccount,
    parent: '',
    code: "",
    op_bal: 0,
    budget: 0,
    days: 0,
    party_id: partyId,
  };

  try {
    const accountRes = await axios.post(
      "https://api.skyguard.group/api/add-account",
      accountData,
      { headers: { "Content-Type": "application/json" } }
    );


    showToast("Account created successfully!", "success");

    if (accountRes.data.insertId) {
      setNewProduct((prev) => ({
        ...prev,
        account_id: accountRes.data.insertId,
      }));
    }
  } catch (accError) {
    console.error("❌ Error creating account:", accError.response?.data || accError.message);
    showToast("Error creating account", "danger");
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    // WORKFLOW A: Opened from Account View (Unified Account & Party workflow)
    if (location.state?.from === "accounts") {
      if (!newProduct.name && !accountData.holder_name) {
        showToast("Please enter Party Name or Account Holder Name", "danger");
        return;
      }

      let partySuccess = false;
      let partyError = null;
      let targetPartyId = newProduct.id || partyId;

      // 1. Update Party if party ID exists
      if (targetPartyId) {
        const formData = new FormData();
        Object.keys(newProduct).forEach((key) => {
          if (
            key === "isAccountChecked" ||
            key === "phoneChecked_one" ||
            key === "phoneChecked" ||
            key === "phoneChecked_two" ||
            key === "phoneChecked_three" ||
            key === "phoneChecked_contact"
          ) {
            formData.append(key, newProduct[key] ? 1 : 0);
          } else if (newProduct[key] !== undefined && newProduct[key] !== null) {
            formData.append(key, newProduct[key]);
          }
        });

        Object.keys(files).forEach((key) => {
          if (files[key]) formData.append(key, files[key]);
        });

        try {
          await axios.put(
            `https://api.skyguard.group/api/update-party/${targetPartyId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          partySuccess = true;
        } catch (error) {
          console.error("❌ Error updating party:", error.response?.data || error.message);
          partyError = error.response?.data?.message || error.message;
        }
      } else {
        // Account had no party originally: create linked party
        const formData = new FormData();
        Object.keys(newProduct).forEach((key) => {
          if (newProduct[key] !== undefined && newProduct[key] !== null) {
            formData.append(key, newProduct[key]);
          }
        });
        if (!newProduct.name && accountData.holder_name) {
          formData.set("name", accountData.holder_name);
        }
        const adminData = JSON.parse(localStorage.getItem("adminData") || "{}");
        if (adminData?.role) {
          formData.append("role", adminData.role);
          formData.append("add_by", adminData.code || "admin");
          formData.append("add_by_id", adminData.company_id || adminData.user?.id || 1);
        }
        try {
          const res = await axios.post(
            "https://api.skyguard.group/api/add-party",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          if (res.status === 200) {
            targetPartyId = res.data.id;
            partySuccess = true;
          }
        } catch (error) {
          console.error("❌ Error adding party:", error.response?.data || error.message);
          partyError = error.response?.data?.message || error.message;
        }
      }

      // 2. Update Account if account ID exists
      let accountSuccess = false;
      let accountError = null;
      let targetAccountId = accountData.id || location.state?.accountId;

      const selectedType = accountData.type_account || newProduct.type_account || "";
      const matchedType = accountType.find(
        (at) => String(at.id) === String(selectedType) || at.type_acc === selectedType
      );
      const finalTypeName = matchedType ? matchedType.type_acc : selectedType;

      if (targetAccountId) {
        const accountPayload = {
          holder_name: accountData.holder_name || newProduct.name,
          code: accountData.code || accountCode,
          type_account: finalTypeName,
          parent: accountData.parent || "",
          op_bal: accountData.op_bal !== undefined && accountData.op_bal !== '' ? accountData.op_bal : 0,
          budget: accountData.budget !== undefined && accountData.budget !== '' ? accountData.budget : 0,
          days: accountData.days !== undefined && accountData.days !== '' ? accountData.days : 0,
        };

        try {
          await axios.put(
            `https://api.skyguard.group/api/update-account/${targetAccountId}`,
            accountPayload
          );
          accountSuccess = true;
        } catch (error) {
          console.error("❌ Error updating account:", error.response?.data || error.message);
          accountError = error.response?.data?.message || error.message;
        }
      } else {
        accountSuccess = true;
      }

      // 3. Consolidated Result Verification (Partial-failure safe)
      if (targetPartyId && targetAccountId) {
        if (partySuccess && accountSuccess) {
          showToast("Party and Account updated successfully!", "success");
          setTimeout(() => navigate("/admin/accounts"), 800);
        } else if (partySuccess && !accountSuccess) {
          showToast(`Party updated, but Account update failed: ${accountError}`, "warning");
        } else if (!partySuccess && accountSuccess) {
          showToast(`Account updated, but Party update failed: ${partyError}`, "warning");
        } else {
          showToast(`Update failed! Party: ${partyError}, Account: ${accountError}`, "danger");
        }
      } else if (targetPartyId) {
        if (partySuccess) {
          showToast("Party updated successfully!", "success");
          setTimeout(() => navigate("/admin/accounts"), 800);
        } else {
          showToast(`Failed to update party: ${partyError}`, "danger");
        }
      } else if (targetAccountId) {
        if (accountSuccess) {
          showToast("Account updated successfully!", "success");
          setTimeout(() => navigate("/admin/accounts"), 800);
        } else {
          showToast(`Failed to update account: ${accountError}`, "danger");
        }
      }
      return;
    }

    // WORKFLOW B: Normal Party Add/Edit (Standard existing behavior preserved)
    if (isEditMode) {
      const formData = new FormData();
      Object.keys(newProduct).forEach((key) => {
        if (
          key === "isAccountChecked" ||
          key === "phoneChecked_one" ||
          key === "phoneChecked" ||
          key === "phoneChecked_two" ||
          key === "phoneChecked_three" ||
          key === "phoneChecked_contact"
        ) {
          formData.append(key, newProduct[key] ? 1 : 0);
        } else if (newProduct[key] !== undefined && newProduct[key] !== null) {
          formData.append(key, newProduct[key]);
        }
      });

      Object.keys(files).forEach((key) => {
        if (files[key]) formData.append(key, files[key]);
      });

      try {
        await axios.put(
          `https://api.skyguard.group/api/update-party/${newProduct.id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("Party Updated Successfully", "success");
        if (newProduct.isAccountChecked && !newProduct.wasAccountChecked) {
          await callAddAccountAPI(newProduct.id, newProduct.name, newProduct.type_account);
        }
        setShowAddForm(false);
        fecthPartyDetail();
        fetchDetail();
      } catch (error) {
        console.error("❌ Error updating:", error.response?.data || error.message);
        showToast("Failed to update party", "danger");
      }
    } else {
      try {
      
        const resCheck = await axios.get("https://api.skyguard.group/api/fetch-party");
        const allParties = resCheck.data; 
        const phoneExists = allParties.some(
          (party) => party.phone === newProduct.phone
        );
        const formData = new FormData();
        Object.keys(newProduct).forEach((key) => {
          formData.append(key, newProduct[key]);
        });
        Object.keys(files).forEach((key) => {
          if (files[key]) formData.append(key, files[key]);
        });

        const adminData = JSON.parse(localStorage.getItem("adminData"));
        const empData = JSON.parse(localStorage.getItem("empData"));

        if (adminData?.role) {
          formData.append("role", adminData.role);
          formData.append("add_by", adminData.code);
          formData.append("add_by_id", adminData.company_id);
        } else if (empData?.designation) {
          formData.append("role", empData.designation);
          formData.append("add_by", "emp");
        } else {
          formData.append("role", "unknown");
          formData.append("add_by", "unknown");
          formData.append("add_by_id", empData?.emp_id || "");
        }
        const res = await axios.post(
          "https://api.skyguard.group/api/add-party",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        showToast("Party added successfully!", "success");
    
        fecthPartyDetail();
        fetchDetail();
      if (newProduct.isAccountChecked) {
        await callAddAccountAPI(res.data.id, newProduct.name, newProduct.type_account);
      }
        setShowAddForm(false);
        setNewProduct({
          name: "",
          parent: "",
          address: "",
          landmark: "",
          city: "",
          pin: "",
          phone: "",
          email: "",
          priority: "",
          type: "",
          remark: "",
          state: "",
          region: "",
          birth: "",
          fax: "",
          mobile: "",
          pan: "",
          gst: "",
          profession: "",
          source: "",
          prodct: "",
          phone_two: "",
          phone_three: "",
          profession_type: "",
          contact_name: "",
          contact_no: "",
          currentAdd: "",
          post_one: '',
          post_two: '',
          post_three: '',
           isAccountChecked: false,
            wasAccountChecked: false,
            customer_type:'',
            alt1_contact_name: '',
            alt2_contact_name: '',
            alt3_contact_name: '',
            cin:'',
            msmse:'',

            
        });
        setAccountCode('');
      } catch (error) {
        console.log("❌ Error adding Party:", error.response?.data || error.message);
        showToast("Error adding Party", "danger");
      }
    }

  }

const fetchPartyById = async (id) => {
  try {
    const res = await axios.get(`https://api.skyguard.group/api/fetch-partyId/${id}`);
  
     setNewProduct({
      id: res.data.id || '',
      name: res.data.name || "",
      parent: res.data.parent || "",
      address: res.data.address || "",
      landmark: res.data.landmark || "",
      city: res.data.city || "",
      pin: res.data.pin || "",
      phone: res.data.phone || "",
      email: res.data.email || "",
      priority: res.data.priority || "",
      type:res.datatype || "",
      remark: res.data.remark || "",
      state:res.data.state || "",
      region: res.data.region || "",
      birth:res.data.birth || "",
      fax:res.data.fax || "",
      mobile: res.data.mobile || "",
      pan:res.data.pan || "",
      gst: res.data.gst || "",
      profession:res.data.profession || '',
      source: res.data.source || '',
      phone_two: res.data.phone_two || '',
      phone_three: res.data.phone_three || '',
      profession_type: res.data.profession_type || '',
      contact_name: res.data.contact_name || '',
      contact_no: res.data.contact_no || '',
      product: res.data.product || '',
      profession: res.data.profession || '',
      source: res.data.source || '',
      currentAdd: res.data.currentAdd || '',
      post_one: res.data.post_one || '',
      post_two: res.data.post_two || '',
      post_three: res.data.post_three || '',
      isAccountChecked: res.data.isAccountChecked ?? false,
        wasAccountChecked:res.data.isAccountChecked === 1,
          phoneChecked_one:res.data.phoneChecked_one || false,
          phoneChecked:res.data.phoneChecked || false,
          phoneChecked_two:res.data.phoneChecked_two || false ,
          phoneChecked_three:res.data.phoneChecked_three || false,
          phoneChecked_contact:res.data.phoneChecked_contact || false,
          customer_type:res.data.customer_type || '',
       alt1_contact_name: res.data.alt1_contact_name || '',
       alt2_contact_name: res.data.alt2_contact_name || '',
       alt3_contact_name: res.data.alt3_contact_name || '',
       cin:res.cin || "",
       msmse:res.msme || "",

      
    })

    setFiles({

      file: res.data.file || null,
      video: res.data.video || null
    });
  } catch (error) {
    console.error(error);
    showToast('Failed to load party data', 'danger');
  }
};


  const fecthPartyDetail = async () => {
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-party');
      const data = res.data;

    //  setDetail(data);
       const sortedData = [...data].sort((a, b) => b.id - a.id); 

    setDetail(sortedData);
      const postOneSet = new Set();
      const postTwoSet = new Set();
      const postThreeSet = new Set();

      data.forEach(item => {
        if (item.post_one) postOneSet.add(item.post_one);
        if (item.post_two) postTwoSet.add(item.post_two);
        if (item.post_three) postThreeSet.add(item.post_three);
      });
      setPostOneOptions(Array.from(postOneSet));
      setPostTwoOptions(Array.from(postTwoSet));
      setPostThreeOptions(Array.from(postThreeSet));
      const uniqueNamesMap = new Map();
      data.forEach(item => {
        if (!uniqueNamesMap.has(item.name)) {
          uniqueNamesMap.set(item.name, item.id);
        }
      });
     const uniqueNames = Array.from(uniqueNamesMap, ([name, id]) => ({ name, id }));
      setParent(uniqueNames);

    } catch (error) {
      console.log(error);
    }
  };

      const fecthAccMasterDetail = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-acc-master');
            setAccountType(resParty.data.result);
            const uniqueTypesAccount = [...new Set(resParty.data.result.map(item => item.type_acc))];
            setFetchAccoutnType(uniqueTypesAccount);   
        } catch (error) {
            console.log(error)
        }
    };


  useEffect(() => {
   fecthAccMasterDetail();
    fecthPartyDetail();
    fetchDetail();
    fetchAccountsList();
  }, []);

  useEffect(() => {
  if (newProduct.id && detail.length > 0) {  
    const partyObj = detail.find(item => item.id === Number(newProduct.id));
    if (partyObj) {
      setAccountCode(partyObj.account_code || "");
    }
  }
}, [detail, partyId]);



  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`https://api.skyguard.group/api/delete-party/${id}`);
      showToast('Party deleted successfully!', 'success')
      fecthPartyDetail();

    } catch (error) {
      console.error("❌ Error deleting:", error.response?.data || error.message);
      showToast("Failed to delete party", 'danger');

    }
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowConfirm(true);
  };
  const confirmDelete = () => {
    handleDelete(deleteId);
    setShowConfirm(false);
  };




  const fetchDetail = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-state");
      const result = res.data.result || [];

      // Extract unique values
      const uniqueStates = [...new Set(result.map((item) => item.state))];
      const uniqueCities = [...new Set(result.map((item) => item.city))];
      const uniqueRegions = [...new Set(result.map((item) => item.region))];
      const uniquePincodes = [...new Set(result.map((item) => item.pincode))];

      setStateOptions(uniqueStates);
      setCityOptions(uniqueCities);
      setRegionOptions(uniqueRegions);
      setPincodeOptions(uniquePincodes);
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    const fecthDetail = async () => {

      try {
        const res = await axios.get('https://api.skyguard.group/api/fetch-master-party');
        setPartyMaster(res.data.result);
        const uniqueTypes = [
          ...new Set(res.data.result.map((item) => item.type)),
        ];
        const typeOptions = uniqueTypes.map((t) => ({
          value: t,
          label: t,
        }));
        setType(typeOptions)
        const uniqueProfession = [
          ...new Set(res.data.result.map((item) => item.profession)),
        ];
        const professionOptions = uniqueProfession.map((p) => ({
          value: p,
          label: p,
        }));
        setProfession(professionOptions)
        const uniqueProfessionType = [
          ...new Set(res.data.result.map((item) => item.type_profession)),
        ];
        const professionTypeOptions = uniqueProfessionType.map((pt) => ({
          value: pt,
          label: pt,
        }));

        setTypeProfession(professionTypeOptions)
        const uniqueSource = [
          ...new Set(res.data.result.map((item) => item.source)),
        ];
        const sourceOptions = uniqueSource.map((s) => ({
          value: s,
          label: s,
        }));

        setSource(sourceOptions)
      } catch (error) {
        console.log(error)
      }
    };
    fecthDetail();
  }, []);




  const filterParty = detail.filter((tt) => {
    const term = (searchTerm || "").toLowerCase();
    return (
      (tt.name && tt.name.toLowerCase().includes(term)) ||
      (tt.phone && tt.phone.toLowerCase().includes(term)) ||
      (tt.mobile && tt.mobile.toLowerCase().includes(term)) ||
      (tt.phone_two && tt.phone_two.toLowerCase().includes(term)) ||
      (tt.phone_three && tt.phone_three.toLowerCase().includes(term)) ||
      (tt.address && tt.address.toLowerCase().includes(term))

    );
  });


  const handlePostChange = (e, field) => {
    if (e.target.value === "__add_new_post__") {
      setActivePostField(field);
      setShowPostModal(true);
    } else {
      setNewProduct({ ...newProduct, [field]: e.target.value });
    }
  };

  const handlePincodeCheck = async () => {
    try {
      const response = await axios.get(
        `https://api.skyguard.group/api/check?pincode=${newProduct.pin}`
      );
      const data = response.data;
      setNewProduct({
        ...newProduct,
        city: data.city,
        state: data.state,
        region: data.region
      });
    } catch (error) {


      if (error.response && error.response.status === 404) {
        showToast("❌ Pincode not found !", 'danger');
      } else {
        showToast("⚠️ Something went wrong while checking the pincode.", 'danger');
      }
      console.error("Error checking pincode:", error);
      setNewProduct({
        ...newProduct,
        city: "",
        state: "",
        region: ""
      });
    }
  };



  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Party Detail</h3>

        <div className="mb-3 row gx-2 gy-2">


          <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">

            <div class="col-12 col-md-9">
              <div className="row my-3 align-items-center">



                {/* Input */}
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name,phone"

                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>



            </div>

            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button
                className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                onClick={() => {
                  setShowAddForm(!showAddForm);
                  if (showAddForm) {
                    // setNewProduct({ name: '', modelno: '', mrp: '', category: '', discount: '' });
                    setEditProductId(null);
                  }
                }}
              >
                {showAddForm ? 'Cancel' : 'Add'}{' '}
                {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
              </button>
            </div>

          </div>




        </div>

        {showAddForm && (
          <div className='card p-3 my-3'  ref={formRef}>

            <h5>{isEditMode ? (location.state?.from === "accounts" ? "Account & Party Details" : "Edit Party Detail") : "Add Party Detail"}</h5>
            <form onSubmit={handleSubmit}>
              <div className='row g-3'>


                      {isEditMode && (
  <div className="mb-3 d-flex align-items-center gap-2">
    <span className="badge bg-primary px-3 py-2 fs-6">
      {newProduct.name || accountData.holder_name}
    </span>
    {(accountData.code || accountCode) && (
      <span className="badge bg-secondary px-3 py-2">
        {accountData.code || accountCode}
      </span>
    )}
    {location.state?.from === "accounts" && (
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm ms-auto"
        onClick={handleCancel}
      >
        Return to Accounts
      </button>
    )}
  </div>
)}
                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Basic Detail
                  </h5>
                </div>

                <div className='col-md-4'>
                  <label>Party Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='name'
                    value={newProduct.name}
                    placeholder='Party Name'
                    onChange={handleInputChange}
                    required
                  />
                </div>

               <div className='col-md-4'>
  <label>Account Code</label>

    <input 
      type='text'
      className='form-control'
      value={accountCode}
      disabled
    />
</div>



                <div className='col-md-4'>
                  <label>Parent Name</label>

                  <select
                    className="form-control"
                    name="parent"
                    value={newProduct.parent}
                    onChange={handleInputChange}

                  >
                    <option value="">Select Parent...</option>


                    {parent.map((p, index) => (
                      <option key={index} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>

                </div>




                <div className='col-md-4'>
                  <label>Landmark</label>
                  <input
                    type='text'
                    className='form-control'
                    name='landmark'
                    value={newProduct.landmark}
                    placeholder='Landmark'
                    onChange={handleInputChange}
                  />
                </div>



                <div className='col-md-4 '>

                  <div className="d-flex align-items-end gap-2">


                    <div className='flex-grow-1 '>
                      <label>Pincode</label>


                      <input
                        type='number'
                        className='form-control'
                        name='pin'
                        value={newProduct.pin}
                        placeholder='Pincode'
                        onChange={handleInputChange}

                        required
                      />
                    </div>

                    <button className='btn btn-primary'
                      type="button"
                      onClick={handlePincodeCheck}
                    >OK </button>
                  </div>
                </div>




                <div className='col-md-4'>
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    name="state"
                    value={newProduct.state}
                    readOnly  
                  />
                </div>

                <div className='col-md-4'>
                  <label>City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={newProduct.city}
                    readOnly
                  />
                </div>

                <div className='col-md-4'>
                  <label>Region</label>
                  <input
                    type="text"
                    className="form-control"
                    name="region"
                    value={newProduct.region}
                    readOnly
                  />
                </div>




                <div className='col-md-4'>
                  <label>Phone No.</label>
                  <input
                    type='tel'
                    className='form-control'
                    name='phone'
                    value={newProduct.phone}
                    placeholder='Phone'
                    onChange={handleInputChange}
                    maxLength={10}
                    required
                  />
              
                    <div className="d-flex justify-content-between align-items-center">


                      {/* Checkbox inside label row */}
                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="phoneCheckbox"
                          checked={newProduct.phoneChecked_one}
                          onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_one: e.target.checked })}
                        />
                        <FaWhatsapp size={20} className='text-success' />
                      </div>

                    </div>
            
                </div>

                <div className='col-md-4'>
                  <label>Alternate Number First.</label>
                  <input
                    type='tel'
                    className='form-control'
                    name='mobile'
                    value={newProduct.mobile}
                    placeholder='Mobile'
                    onChange={handleInputChange}
                    maxLength={10}

                  />
             
                    <div className="d-flex justify-content-between align-items-center">



                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="phoneCheckbox"
                          checked={newProduct.phoneChecked}
                          onChange={(e) => setNewProduct({ ...newProduct, phoneChecked: e.target.checked })}
                        />
                        <FaWhatsapp size={20} className='text-success' />
                        <label className="form-check-label small" htmlFor="phoneCheckbox">

                        </label>
                      </div>

                    </div>
                 
                </div>


               
                <div className="col-md-4">
                  <label>Post 1</label>
                  <select
                    className="form-control"
                    name="post_one"
                    value={newProduct.post_one}
                    onChange={(e) => handlePostChange(e, "post_one")}
                  >
                    <option value="">-- Select Post 1 --</option>
                    {postOneOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    <option value="__add_new_post__">➕ Add New Post</option>
                  </select>
              
                </div>


                {showPostModal && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Add New Post</h5>
                          <button className="btn-close" onClick={() => setShowPostModal(false)}></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="text"
                            className="form-control"
                            value={newPostName}
                            onChange={(e) => setNewPostName(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button
                            className="btn btn-secondary"
                            onClick={() => {
                              setShowPostModal(false);
                              setNewPostName("");
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-success"
                            onClick={() => {
                              if (!newPostName.trim()) return;

                              // Add to correct post options
                              if (activePostField === "post_one") {
                                setPostOneOptions([...postOneOptions, newPostName]);
                              } else if (activePostField === "post_two") {
                                setPostTwoOptions([...postTwoOptions, newPostName]);
                              } else if (activePostField === "post_three") {
                                setPostThreeOptions([...postThreeOptions, newPostName]);
                              }

                              // Set selected value
                              setNewProduct({ ...newProduct, [activePostField]: newPostName });

                              // Reset
                              setNewPostName("");
                              setShowPostModal(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className='col-md-4'>
                  <label>Alternate 1 Contact Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='alt1_contact_name'
                    value={newProduct.alt1_contact_name || ''}
                    placeholder='Contact Name'
                    onChange={handleInputChange}
                  />
                </div>




                <div className='col-md-4'>
                  <label>Alternate Number Second </label>
                  <input
                    type='tel'
                    className='form-control'
                    name='phone_two'
                    value={newProduct.phone_two}
                    placeholder='Phone'
                    onChange={handleInputChange}
                    maxLength={10}
                  />

             
                    <div className="d-flex justify-content-between align-items-center">


                      {/* Checkbox inside label row */}
                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="phoneCheckbox"
                          checked={newProduct.phoneChecked_two}
                          onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_two: e.target.checked })}
                        />
                        <FaWhatsapp size={20} className='text-success' />
                      </div>
                    </div>
               

                </div>



                <div className="col-md-4">
                  <label>Post 2</label>



                  <select
                    className="form-control"
                    name="post_two"
                    value={newProduct.post_two}
                    onChange={(e) => handlePostChange(e, "post_two")}
                  >
                    <option value="">-- Select Post 2 --</option>
                    {postTwoOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    <option value="__add_new_post__">➕ Add New Post</option>
                  </select>

                </div>

                <div className='col-md-4'>
                  <label>Alternate 2 Contact Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='alt2_contact_name'
                    value={newProduct.alt2_contact_name || ''}
                    placeholder='Contact Name'
                    onChange={handleInputChange}
                  />
                </div>


                <div className='col-md-4'>
                  <label>Alternate Number Third</label>
                  <input
                    type='tel'
                    className='form-control'
                    name='phone_three'
                    value={newProduct.phone_three}
                    placeholder='Phone'
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                
                    <div className="d-flex justify-content-between align-items-center">


                      {/* Checkbox inside label row */}
                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="phoneCheckbox"
                          checked={newProduct.phoneChecked_three}
                          onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_three: e.target.checked })}
                        />
                        <FaWhatsapp size={20} className='text-success' />
                      </div>
                    </div>
            
                </div>


                <div className="col-md-4">
                  <label>Post 3</label>


                  <select
                    className="form-control"
                    name="post_three"
                    value={newProduct.post_three}
                    onChange={(e) => handlePostChange(e, "post_three")}
                  >
                    <option value="">-- Select Post 3 --</option>
                    {postThreeOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
                    <option value="__add_new_post__">➕ Add New Post</option>
                  </select>

                </div>

                <div className='col-md-4'>
                  <label>Alternate 3 Contact Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='alt3_contact_name'
                    value={newProduct.alt3_contact_name || ''}
                    placeholder='Contact Name'
                    onChange={handleInputChange}
                  />
                </div>

                <div className='col-md-4'>
                  <label>Email</label>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    value={newProduct.email}
                    placeholder='Email'
                    onChange={handleInputChange}
                    required
                  />
                </div>

               <div className="col-md-4">
  <label>Customer Type</label>
  <select className="form-control"
   name="customer_type"
                    value={newProduct.customer_type}
                       onChange={handleInputChange}
                    required
  >
    <option value="">Select Customer Type</option>
    <option value="vendor">Vendor</option>
    <option value="retailer">Retailer</option>
  </select>
</div>





                <div className='col-md-4'>
                  <label>Address</label>

                  <textarea
                    className="form-control"
                    name="address"
                    placeholder="Enter here..."
                    value={newProduct.address}
                    onChange={handleInputChange}
                    rows={4}
                  />
                </div>



                <div className='col-md-4'>
                  <label>Add Location</label>

                  <textarea
                    className="form-control"
                    name="currentAdd"
                    placeholder="Enter here..."
                    value={newProduct.currentAdd}
                 
                    onChange={(e) =>
                      setNewProduct((prev) => ({ ...prev, currentAdd: e.target.value }))
                    }
                    rows={4}
                  />

           
                  <button
                    type="button"
                    className="btn btn-primary mt-2"
                    onClick={getCurrentLoc}   
                  >
                    Use Current Location
                  </button>
                </div>

                <div className="mb-0   bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Other Detail
                  </h5>
                </div>


                <div className='col-md-4'>
                  <label>Contact Person Name</label>
                  <input
                    type='text'
                    className='form-control'
                    name='contact_name'
                    value={newProduct.contact_name}
                    placeholder='Contact Person Name'
                    onChange={handleInputChange}
                  />
                </div>

                <div className='col-md-4'>
                  <label>Contact Person Number</label>
                  <input
                    type='tel'
                    className='form-control'
                    name='contact_no'
                    value={newProduct.contact_no}
                    placeholder='Contact Person Number'
                    onChange={handleInputChange}
                    maxLength={10}
                  />
             
                    <div className="d-flex justify-content-between align-items-center">
                   <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="phoneCheckbox"
                          checked={newProduct.phoneChecked_contact}
                          onChange={(e) => setNewProduct({ ...newProduct, phoneChecked_contact: e.target.checked })}
                        />
                        <FaWhatsapp size={20} className='text-success' />
                      </div>
                    </div>
              
                </div>






                <div className='col-md-4'>
                  <laebl>Pan</laebl>
                  <input
                    type='text'
                    className='form-control'
                    name='pan'
                    value={newProduct.pan}
                    placeholder='Pan'
                    onChange={handleInputChange}
                  />
                </div>
                <div className='col-md-4'>
                  <label>GST No</label>
                  <input
                    type='text'
                    className='form-control'
                    name='gst'
                    value={newProduct.gst}
                    placeholder='GST'
                    onChange={handleInputChange}
                  />
                </div>


                 <div className='col-md-4'>
                  <label>CIN No</label>
                  <input
                    type='text'
                    className='form-control'
                    name='cin'
                    value={newProduct.cin}
                    placeholder='CIN No'
                    onChange={handleInputChange}
                  />
                </div>

                 <div className='col-md-4'>
                  <label>MSME</label>
                  <input
                    type='text'
                    className='form-control'
                    name='msme'
                    value={newProduct.msme}
                    placeholder='MSME No'
                    onChange={handleInputChange}
                  />
                </div>
                <div className='col-md-4'>
                  <label>Priority</label>

                  <Select
                    options={priorityOptions}
                    placeholder="Choose Priority..."
                    id="Priority"
                    value={priorityOptions.find(option => option.label === newProduct.priority)}
                    onChange={(selectedOption) =>
                      setNewProduct({ ...newProduct, priority: selectedOption.label })
                    }
                  />
                </div>

                <div className='col-md-4'>
                  <label htmlFor="type-select">Sector:</label><br />


                  <Select
                    options={type}
                    placeholder="Choose Sector ..."
                    id="type"
                    value={type.find((opt) => opt.value === newProduct.type) || null}
                    onChange={(selectedOption) =>
                      setNewProduct({ ...newProduct, type: selectedOption.value, }) 
                    }
                  />



                </div>





                <div className='col-md-4'>
                  <laebl>Product Category</laebl>


                  <Select
                    options={profession}
                    placeholder="Choose Product Category..."
                    id="profession"
                    value={profession.find((opt) => opt.value === newProduct.profession) || null}
                    onChange={(selectedOption) =>
                      setNewProduct({ ...newProduct, profession: selectedOption.value, })
                    }
                  />

                </div>

                <div className='col-md-4'>
                  <laebl>Type of  Profession</laebl>

                  <Select
                    options={typeProfessin}
                    placeholder="Choose Type ..."
                    id="typeProfessin"
                    value={typeProfessin.find((opt) => opt.value === newProduct.profession_type) || null}
                    onChange={(selectedOption) =>
                      setNewProduct({ ...newProduct, profession_type: selectedOption.value, })
                    }
                  />
                </div>
                <div className='col-md-4'>
                  <laebl>Source</laebl>
                  <Select
                    options={source}
                    placeholder="Choose Type ..."
                    id="source"
                    value={source.find((opt) => opt.value === newProduct.source) || null}
                    onChange={(selectedOption) =>
                      setNewProduct({ ...newProduct, source: selectedOption.value, })
                    }
                  />
                </div>

                <div className='col-md-4'>
                  <laebl>Source of Product </laebl>
                  <input
                    type='text'
                    className='form-control'
                    name='product'
                    value={newProduct.product}
                    placeholder='Source Of Product'
                    onChange={handleInputChange}
                  />
                </div>




                <div className='col-md-4'>
                  <laebl>Birth Day</laebl>
                  <input
                    type='date'
                    className='form-control'
                    name='birth'
                    value={newProduct.birth}
                    placeholder='Birth Day'
                    onChange={handleInputChange}
                  />
                </div>
                <div className='col-md-4'>
                  <laebl>Website</laebl>
                  <input
                    type='text'
                    className='form-control'
                    name='fax'
                    value={newProduct.fax}
                    placeholder='Website'
                    onChange={handleInputChange}
                  />
                </div>

                <div className='col-md-4'>
                  <laebl>Remark</laebl>

                  <textarea
                    className="form-control"
                    name="remark"
                    placeholder="Enter here..."
                    value={newProduct.remark}
                    onChange={handleInputChange}
                    rows={4}
                  />
                </div>
                <hr />

                {!(isEditMode && hasAccount) && ( 

  
                <div className="form-check mb-0">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={newProduct.isAccountChecked}
                    onChange={(e) =>
                      setNewProduct({
                        ...newProduct,
                        isAccountChecked: e.target.checked,
                      })
                    }
                    id="phoneCheckbox"
                  />
                  <label className="form-check-label small" htmlFor="phoneCheckbox">
                    Create Account
                  </label>
                </div>
     )}
                
{newProduct.isAccountChecked && !(isEditMode && hasAccount) && (
  <div className="col-md-4">
    <label>Type Of Account</label>
    <select
      className="form-control"
      name="type_account"
      value={newProduct.type_account}
      onChange={handleInputChange}
    >
      <option value="">-- Select Type --</option>
      {fetchAccountType.map((t, index) => (
        <option key={index} value={t.trim()}>
          {t.trim()}
        </option>
      ))}
    </select>
  </div>
)}





                <div className="mb-0  bold">
                  <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                    Upload Document
                  </h5>
                </div>

                <div className='col-md-4'>
                  <label>Upload File</label>
                  {isEditMode && files.file && typeof files.file === "string" && (
                    <div style={{ marginBottom: 10 }}>
                      <span>Previous file: </span>
                      <a
                        href={`https://api.skyguard.group/uploads/${files.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {files.file}
                      </a>
                    </div>
                  )}
                  <input type="file" className="form-control" name="file" accept="image/*,application/pdf" onChange={handleFileChange} />
                </div>


                <div className='col-md-4'>
                  <label>Upload Video</label>
                  {isEditMode && files.video && typeof files.video === "string" && (
                    <div style={{ marginBottom: 10 }}>
                      <span>Previous Video: </span>
                      <a
                        href={`https://api.skyguard.group/uploads/${files.video}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {files.video}
                      </a>
                    </div>
                  )}
                  <input
                    type="file"
                    className="form-control"
                    name="video"
                    accept="video/*"
                    onChange={handleVideoChange}
                  />
                </div>



              
                {/* Account Details Section */}
                {Boolean(location.state?.from === "accounts") && (
                  <>
                    <div className="mb-0 bold mt-3 col-12">
                      <h5 className="btn btn-primary btn-sm rounded-pill d-inline-block fw-bold px-3 py-2">
                        Account Details
                      </h5>
                    </div>

                    <div className="col-md-4">
                      <label>Account Holder Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="holder_name"
                        value={accountData.holder_name !== undefined ? accountData.holder_name : (newProduct.name || '')}
                        onChange={handleAccountInputChange}
                        placeholder="Account Holder Name"
                      />
                    </div>

                    <div className="col-md-4">
                      <label>Account Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="code"
                        value={accountData.code || accountCode || ""}
                        readOnly
                        placeholder="Auto-generated / Code"
                      />
                    </div>

                    <div className="col-md-4">
                      <label>Type Of Account</label>
                      <select
                        className="form-control"
                        name="type_account"
                        value={(() => {
                          const val = accountData.type_account || newProduct.type_account;
                          const found = accountType.find(
                            (at) => String(at.id) === String(val) || at.type_acc === val
                          );
                          return found ? found.type_acc : (val || "");
                        })()}
                        onChange={handleAccountInputChange}
                      >
                        <option value="">-- Select Type --</option>
                        {fetchAccountType.map((t, index) => (
                          <option key={index} value={t.trim()}>
                            {t.trim()}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label>Parent Account</label>
                      <select
                        className="form-control"
                        name="parent"
                        value={accountData.parent || ""}
                        onChange={handleAccountInputChange}
                      >
                        <option value="">Select Parent...</option>
                        {parentAccounts.map((p, index) => (
                          <option key={index} value={p.id}>
                            {p.holder_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label>Op. Bal</label>
                      <input
                        type="text"
                        className="form-control"
                        name="op_bal"
                        value={accountData.op_bal !== undefined ? accountData.op_bal : ""}
                        onChange={handleAccountInputChange}
                        placeholder="Opening Balance"
                      />
                    </div>

                    <div className="col-md-4">
                      <label>Limit/Budget</label>
                      <input
                        type="text"
                        className="form-control"
                        name="budget"
                        value={accountData.budget !== undefined ? accountData.budget : ""}
                        onChange={handleAccountInputChange}
                        placeholder="Limit / Budget"
                      />
                    </div>

                    <div className="col-md-4">
                      <label>Days</label>
                      <input
                        type="text"
                        className="form-control"
                        name="days"
                        value={accountData.days !== undefined ? accountData.days : ""}
                        onChange={handleAccountInputChange}
                        placeholder="Days"
                      />
                    </div>
                  </>
                )}
              </div>
              <div className='col-md-12 mt-4 d-flex align-items-center gap-2'>
                <button type="submit" className='btn btn-success px-4'>
                  {isEditMode ? "Update" : "Save"}
                </button>
                <button type='button' className='btn btn-danger px-4' onClick={handleCancel}>
                  {location.state?.from === "accounts" ? "Close (Return to Account List)" : "Cancel"}
                </button>
              </div>
            </form>

          </div>
        )}

        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                <th scope='col'>SN</th>
                   <th scope='col'>Action</th>
                <th scope='col'>Party Name</th>
                <th scope='col'>Email</th>
                <th scope='col'>Phone</th>
                <th scope='col'>City</th>
                <th scope='col'>Region</th>
             
              </tr>
            </thead>
            <tbody>
              {filterParty.length > 0 ? (
                filterParty.map((inv, index) => (
                  <tr key={inv.id}>
                    <td>{filterParty.length - index}</td>
                        <td>
                      <button
                        className='btn btn-primary'
                        // onClick={() => handleEdit(inv)}
                        onClick={() => {
    handleEdit(inv);

    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }}
                      >
                        <MdEdit />
                      </button>&nbsp;
                      <button
                        className='btn btn-danger'
                        // onClick={() => handleDelete(inv.id)}
                        onClick={() => handleDeleteClick(inv.id)}
                      >
                        <AiOutlineDelete  />
                      </button>
                    </td>
                    <td>{inv.name}</td>
                    <td>{inv.email}</td>
                    <td>{inv.phone}</td>
                    <td>{inv.city}</td>
                    <td>{inv.region}</td>
                
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No data found.</td>
                </tr>
              )
              }


              {showConfirm && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                  <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm Delete</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowConfirm(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <p>Are you sure you want to delete this party?</p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowConfirm(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={confirmDelete}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default PartyDetail